module.exports = __webpack_public_path__ + "img/clipboard.92087576.svg";